import React from "react";
import { Col, Container, Row } from "react-bootstrap";

function Seoresults() {
  return (
    <section className="seo_results p-100">
      <Container>
        <Row>
          <Col
            xs={12}
            md={10}
            lg={9}
            xl={9}
            xxl={9}
            className="m-auto text-center"
          >
            <h2>
              The <span>Benefits of Cutting-Edge</span> Progressive Web App
              Solutions at TekRevol
            </h2>
          </Col>
        </Row>
        <Row className="mt-3 mt-md-4">
          <Col xs={12} md={12} lg={12} xl={12} xxl={12} className="">
            <div className="seo-result-main">
              <div className="seo-result-item">
                <div className="seo-result-box">
                  <div className="seo-num">01</div>
                  <h5>
                    Smooth User
                    <br /> Experience
                  </h5>
                  <p>
                    With our PWAs, the user experience is truly unmatchable as
                    the user interface is extremely simple and responsive, be it
                    on smartphones, tablets, or desktop PCs. The apps offer fast
                    loading times with easy navigation and we guarantee you that
                    the user will have the same native-app-like experience with
                    our PWA.
                  </p>
                </div>
              </div>
              <div className="seo-result-item">
                <div className="seo-result-box">
                  <div className="seo-num">02</div>
                  <h5>
                    Offline
                    <br /> Functionality
                  </h5>
                  <p>
                    TekRevol’s PWAs offer offline functionality which is one of
                    its key features. For instance, TekRevol’s PWAs come with
                    offline capabilities where the user can easily access or
                    interact with the app without any internet connection.
                  </p>
                </div>
              </div>
              <div className="seo-result-item">
                <div className="seo-result-box">
                  <div className="seo-num">03</div>
                  <h5>
                    Performance and
                    <br /> Speed
                  </h5>
                  <p>
                    The cutting-edge technology used in TekRevol’s PWA allows
                    for optimized performance with no lags and delivers
                    high-speed performance. This is one key feature that
                    contributes towards customer satisfaction with PWAs and high
                    retention rates as well in the long run.
                  </p>
                </div>
              </div>
              <div className="seo-result-item">
                <div className="seo-result-box">
                  <div className="seo-num">04</div>
                  <h5>Cost-Effective Development</h5>
                  <p>
                    Our approach to PWA development simplifies the entire
                    process, resulting in reduced development and maintenance
                    costs. This gives our clients adequate room to invest more
                    in features and functionality that will result in
                    sustainable business growth.
                  </p>
                </div>
              </div>
              <div className="seo-result-item">
                <div className="seo-result-box">
                  <div className="seo-num">05</div>
                  <h5>
                    Cross-platform
                    <br /> Compatibility
                  </h5>
                  <p>
                    TekRevol’s PWA are designed such that they are widely
                    compatible across different platforms and different devices.
                    This also results in reduced development costs.
                  </p>
                </div>
              </div>
              <div className="seo-result-item">
                <div className="seo-result-box">
                  <div className="seo-num">06</div>
                  <h5>
                    Search Engine
                    <br /> Visibility
                  </h5>
                  <p>
                    PWAs are indexed by search engines as it is an easy and more
                    accessible way to make your product reachable to the target
                    audience. This will boost organic traffic and also enhance
                    your brand’s visibility.
                  </p>
                </div>
              </div>
              <div className="seo-result-item">
                <div className="seo-result-box">
                  <div className="seo-num">07</div>
                  <h5>Security</h5>
                  <p>
                    At TekRevol, we prioritize security over everything else by
                    using HTTPS and other modern protocols so that the app and
                    the user data are protected without any external threats.
                  </p>
                </div>
              </div>
            </div>
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default Seoresults;
